import { Link } from "react-router-dom";

export default function App() {
  return (
    <div>
      <h1>Welcome my demo ec2+react+nginx</h1>
      <nav
        style={{
          borderBottom: "solid 1px",
          paddingBottom: "1rem",
        }}
      >
        <Link to="/paekabu">paekabu page</Link> |{" "}
      </nav>
    </div>
  );
}
